import { render, staticRenderFns } from "./PlayIcon.vue?vue&type=template&id=56f641c9&scoped=true"
import script from "./PlayIcon.vue?vue&type=script&lang=js"
export * from "./PlayIcon.vue?vue&type=script&lang=js"
import style0 from "./PlayIcon.vue?vue&type=style&index=0&id=56f641c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f641c9",
  null
  
)

export default component.exports